var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndicator3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 28c0-1.9 3-5 3-5s3 3.1 3 5-1.5 3-3 3-3-1.1-3-3Z",
  stroke: "#0394E3",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 14h-4c-1.103 0-2 .897-2 2v3H3v-3c0-4.411 3.589-8 8-8h4M23 8h6v6h-6",
  stroke: "#0394E3",
  strokeWidth: 2,
  strokeMiterlimit: 10
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 1h12M19 6V1M19 16a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  stroke: "#0394E3",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
})));
export default SvgIndicator3;